import { useTranslation } from 'react-i18next'
import { PlaceholderPage } from '@/shared/components/PlaceholderPage.tsx'

export function ForecastsPage() {
  const { t } = useTranslation()
  return (
    <PlaceholderPage title={t('nav.forecasts')} description={t('pages.forecasts.description')} />
  )
}
